import { ref, readonly } from 'vue'
import { useRouter } from 'vue-router'

import appAnalytics from '@/utils/tracking'

import { selectedAccommodationId } from '@/layouts/queries'

const isPopupOpen = ref(false)
const popupConfig = ref({
  text: '',
  buttonLabel: '',
  onAction: null,
})

export function useEligibilityPopup() {
  const router = useRouter()

  const openPopup = config => {
    popupConfig.value = {
      text: config.text || '',
      buttonLabel: config.buttonLabel || 'Got it',
      onAction: config.onAction || null,
    }
    isPopupOpen.value = true
  }

  const closePopup = () => {
    isPopupOpen.value = false
    setTimeout(() => {
      popupConfig.value = {
        text: '',
        buttonLabel: '',
        onAction: null,
      }
    }, 300)
  }

  const handleAction = () => {
    if (popupConfig.value.onAction && typeof popupConfig.value.onAction === 'function') {
      popupConfig.value.onAction()
    }
    closePopup()
  }

  /**
   * Redirect user based on eligibility status
   * @param {boolean} isEligible - Whether user is eligible for Rate Connect
   */
  const redirectToRateConnect = isEligible => {
    if (isEligible) {
      // User is eligible but hasn't started campaign → Go to campaign setup
      appAnalytics.track(appAnalytics.events.HOMEPAGE_LOCK_ICON_START_CAMPAIGN_CLICKED, {
        itemId: selectedAccommodationId.value,
      })
      router.push({ name: 'rate-connect-no-campaign' })
    } else {
      appAnalytics.track(appAnalytics.events.HOMEPAGE_LOCK_ICON_LEARN_MORE_CLICKED, {
        itemId: selectedAccommodationId.value,
      })
      router.push({ name: 'rate-connect-not-eligible' })
    }
  }

  /**
   * Open popup for locked metrics
   * @param {boolean} isEligible - Whether user is eligible for Rate Connect
   */
  const openLockedMetricPopup = (isEligible = false) => {
    openPopup({
      text: isEligible ? 'rc_performance_eligible' : 'rc_performance_non_eligible',
      buttonLabel: isEligible ? 'rc_performance_eligible_cta' : 'rc_performance_learn_more',
      onAction: () => {
        redirectToRateConnect(isEligible)
      },
    })
  }

  return {
    // State (readonly to prevent direct mutation)
    isPopupOpen: readonly(isPopupOpen),
    popupConfig: readonly(popupConfig),

    // Methods
    openPopup,
    closePopup,
    handleAction,
    openLockedMetricPopup,
  }
}
